import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { TitleContext } from "../../../../../Context/TitleContext";
import { API_URL, useAxios } from "../../../../../utils/const";
import { useToast } from "../../../../../Context/ToastContext";
import moment from "moment";
import CheckInStudentModal from "./CheckInStudentModal";
import UploadLogbookModal from "./UploadLogbookModal";

const CourseAttendanceStudent = () => {

  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const MySwal = withReactContent(Swal);
  const { id, course_type } = useParams();

  const [courseSession, setCourseSession] = useState([]);
  const [location, setLocation] = useState({ latitude: "", longitude: "" });
  const [checkInTime, setCheckInTime] = useState("");
  const [checkInStatus, setCheckInStatus] = useState(() => {
    // Cek apakah status check-in untuk ID mahasiswa ada di localStorage
    const savedStatus = JSON.parse(localStorage.getItem("checkInStatus"));
    return savedStatus && savedStatus.id === id ? savedStatus.status : null;
  });

  const [loading, setLoading] = useState(true);
  const [openCheckInStudentModal, setOpenCheckInStudentModal] = useState(false);
  const [openUploadLogbookModal, setOpenUploadLogbookModal] = useState(false);

  useEffect(() => {
    setTitle("USAKTI | Absensi"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getCourseSession();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const showSwal = async () => {
    // if (navigator.geolocation) {
    // navigator.geolocation.getCurrentPosition(
    // async (position) => {
    const currentTime = await getCurrentTime();
    setCheckInTime(currentTime);
    setLocation({
      latitude: "-6.282598472869573",
      longitude: "106.72064216377761",
    });
    // setLocation({ latitude: position.coords.latitude, longitude: position.coords.longitude })
    setOpenCheckInStudentModal(true);
    // },
    // (error) => {
    //   // Lokasi tidak aktif, tampilkan pesan peringatan
    //   MySwal.fire({
    //     icon: "warning",
    //     title: "Oops",
    //     text: "Pengguna tidak mengizinkan akses lokasi, lokasi Universitas akan digunakan",
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "OK",
    //   });
    // }
    // );
    // } else {
    //   // Geolocation tidak tersedia
    //   MySwal.fire({
    //     icon: "error",
    //     title: "Gagal",
    //     text: "Browser tidak mendukung Geolocation",
    //     confirmButtonColor: "#3085d6",
    //     confirmButtonText: "OK",
    //   });
    // }
  };

  const getCourseSession = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-sessions/student/${id}/${course_type}`
    );
    setCourseSession(response.data.data);
  };

  const formatDate = (isoDate) => {
    // Format using moment
    return moment(isoDate).format("DD MMM YYYY");
  };

  const getCurrentTime = async () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0"); // Add leading zero if needed
    const minutes = String(now.getMinutes()).padStart(2, "0"); // Add leading zero if needed
    return `${hours}:${minutes}`;
  };

  const toggleOpenUploadLogbookModal = () => {
    setOpenUploadLogbookModal(true);
  };

  return loading == false ? (
    <div className="container-fluid">
      <div className="card mb-4">
        <div className="card-body">
          <h1>Presensi Akademik</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">Presensi Akademik</li>
          </ol>
        </div>
      </div>

      {/* TIMESHEET */}
      <div className="row">
        <div className="col-md-5 mb-4">
          <div className="card">
            <div className="card-body">
              <h6 className="card-title">Timesheet</h6>
              <p style={{ color: "#747474" }}>
                <strong>{courseSession.courseGroup.course.name}</strong>
                <br></br>
                {courseSession.courseTopic.topic} - {courseSession.course_type}{" "}
                - Kelompok {courseSession.courseGroup.group.name}
              </p>
              <div className="punch-det mt-3">
                <p className="m-0" style={{ fontSize: "0.75rem" }}>
                  Absensi
                </p>
                <p style={{ fontSize: "0.75rem" }}>
                  {formatDate(courseSession.date)} ({courseSession.start_time} -{" "}
                  {courseSession.end_time})
                </p>
              </div>
              <div className="punch-btn-section">
                <div className="row justify-content-center">
                  <button
                    className={`btn ${
                      courseSession.status !== 1 ||
                      courseSession.student[0].status !== 0
                        ? "btn-danger"
                        : "btn-success"
                    } punch-btn`}
                    style={{ width: "70%" }}
                    disabled={
                      courseSession.status !== 1 ||
                      courseSession.student[0].status !== 0
                    }
                    onClick={showSwal}
                  >
                    {courseSession.status !== 1
                      ? "Kelas Belum Dibuka"
                      : courseSession.student[0].status === 0
                      ? "Masuk"
                      : `Berhasil masuk pada pukul ${courseSession.student[0].check_in}` ||
                        "Masuk"}
                  </button>
                </div>
                {courseSession.course_type.includes("TUTORIAL") && (
                  <div className="row mt-3 justify-content-center">
                    <button
                      disabled={courseSession.status !== 1}
                      className="btn btn-primary punch-btn"
                      style={{ width: "70%" }}
                      onClick={toggleOpenUploadLogbookModal}
                    >
                      Upload Logbook
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {openCheckInStudentModal && (
        <CheckInStudentModal
          toggleModal={setOpenCheckInStudentModal}
          getCourseSession={getCourseSession}
          location={location}
          checkInTime={checkInTime}
          student={courseSession}
          setCheckInStatus={setCheckInStatus}
          courseId={id}
        />
      )}
      {openUploadLogbookModal && (
        <UploadLogbookModal
          toggleModal={setOpenUploadLogbookModal}
          getCourseSession={getCourseSession}
          student={courseSession}
        />
      )}
    </div>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CourseAttendanceStudent;
